import Club from '@/pages/Club';
import ClubsExplorer from '@/pages/ClubsExplorer';
import CreateRound from '@/pages/CreateRound';
import DebugPage from '@/pages/DebugPage';
import Discover from '@/pages/Discover';
import Topic from '@/pages/discover/Topic';
import EditClubPage from '@/pages/EditClubPage';
import EditMyBag from '@/pages/EditMyBag';
import Friends from '@/pages/Friends';
import GameSettings from '@/pages/GameSettings';
import ClubsExplorerSearch from '@/pages/ClubsExplorerSearch';
import Landing from '@/pages/Landing';
import MenuPage from '@/pages/MenuPage';
import MyBag from '@/pages/MyBag';
import NotificationsPage from '@/pages/NotificationsPage';
import PlayGame from '@/pages/PlayGame';
import PostPage from '@/pages/PostPage';
import Settings from '@/pages/Settings';
import StatsPage from '@/pages/StatsPage';
import UserPage from '@/pages/UserPage';
import UserGamesPage from '@/pages/UserGamesPage';
import UserStatsPage from '@/pages/UserStatsPage';
import UserBag from '@/pages/UserBag';
import Achievements from '@/pages/Achievements';
import { Capacitor } from '@capacitor/core';
import { IonRouterOutlet } from '@ionic/react';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import GameResult from './game-result/GameResult';
import MessagesNew from '@/pages/MessagesNew';

interface GolfRouterProps {
  hasProfile: boolean;
}

const GolfRouter: React.FC<GolfRouterProps> = ({ hasProfile }) => {
  return (
    <IonRouterOutlet>
      {/* Play golf routes */}
      <Route exact path="/play/:gameId" component={PlayGame} />
      <Route exact path="/game/:gameId/settings" component={GameSettings} />
      <Route exact path="/game/:gameId/result" component={GameResult} />
      <Route exact path="/stats" component={StatsPage} />

      <Route exact path="/dashboard" component={Discover} />
      <Route exact path="/discover" component={Discover} />
      <Route exact path="/discover/topic/:topicName" component={Topic} />
      <Route exact path="/friends" component={Friends} />
      <Route exact path="/messages" component={MessagesNew} />
      <Route exact path="/messages/:chatId" component={MessagesNew} />
      <Route exact path="/notifications" component={NotificationsPage} />
      <Route exact path="/explore" component={ClubsExplorer} />

      {/* Search routes - new Airbnb-style search with /s/ pattern */}
      <Route exact path="/s" component={ClubsExplorerSearch} />
      <Route exact path="/s/:country" component={ClubsExplorerSearch} />
      <Route exact path="/s/:country/:state" component={ClubsExplorerSearch} />

      {/* Individual club routes */}
      <Route exact path="/c/:courseId" component={Club} />
      <Route exact path="/c/edit/:courseId" component={EditClubPage} />

      {/* Country and state filtering routes */}
      <Route exact path="/menu" component={MenuPage} />
      <Route path="/settings" component={Settings} />
      <Route exact path="/debug" component={DebugPage} />

      {/* User routes */}
      <Route exact path="/u/:username" component={UserPage} />
      <Route exact path="/u/:userId/games" component={UserGamesPage} />
      <Route exact path="/u/:userId/stats" component={UserStatsPage} />
      <Route exact path="/u/:userId/bag" component={UserBag} />
      <Route exact path="/u/:userId/achievements" component={Achievements} />
      <Route exact path="/p/:postId" component={PostPage} />

      {/* Current user routes */}
      <Route exact path="/create-round" component={CreateRound} />
      <Route exact path="/my-bag" component={MyBag} />
      <Route exact path="/my-bag/edit" component={EditMyBag} />
      <Route exact path="/achievements" component={Achievements} />
      <Route exact path="/" render={() => Capacitor.isNativePlatform() ? <Redirect to="/dashboard" /> : hasProfile ? <Redirect to="/dashboard" /> : <Landing />} />
      <Redirect to='/dashboard' />
    </IonRouterOutlet>
  );
};
export default GolfRouter;